import {
  httpDeleteFieldsByFieldName,
  httpGetFields,
  httpPatchFieldsByFieldName,
  httpPostFields,
  type MetadataHttpGetFieldsQuery,
  type MetadataMetadataFieldCreateSchema,
  type MetadataMetadataFieldSchemaPartial,
} from '@iconik-io/iconik-api/src/services/metadata';

import type { AppDispatch } from '../../../store/types';
import {
  wrapCommonCreate,
  wrapCommonDelete,
  wrapCommonGetList,
} from '../../common_list/thunks';

export function getMetadataFields(
  debounce?: boolean,
  query?: MetadataHttpGetFieldsQuery,
) {
  return (dispatch: AppDispatch) =>
    wrapCommonGetList({
      prefix: 'admin_metadata_fields',
      params: {},
      dispatch,
      debounce,
      getListPromise: () => dispatch(httpGetFields(query)),
    });
}

export function createMetadataField(data: MetadataMetadataFieldCreateSchema) {
  return (dispatch: AppDispatch) =>
    wrapCommonCreate({
      prefix: 'admin_metadata_fields',
      dispatch,
      createPromise: dispatch(httpPostFields(data)),
    });
}

export function updateMetadataField(
  id: string,
  data: MetadataMetadataFieldSchemaPartial,
) {
  return (dispatch: AppDispatch) =>
    dispatch(httpPatchFieldsByFieldName(id, data));
}

export function deleteMetadataFieldsByIds(ids: string[]) {
  return (dispatch: AppDispatch): Promise<void> =>
    wrapCommonDelete({
      prefix: 'admin_metadata_fields',
      dispatch,
      ids,
      deletePromise: Promise.all(
        ids.map((id) => dispatch(httpDeleteFieldsByFieldName(id))),
      ),
    });
}
